import * as React from 'react';
import * as cx from 'classnames';

import { TransitionGroup, CSSTransition } from 'react-transition-group';

import SearchMapPreviewControls from './SearchMapPreviewControls';
import ListingPreviewCardTracked from '../../containers/ListingPreviewCardTracked';
import { ListingPreviewCard } from 'ha/services/apiV2/types/AlgoliaListing';

import { Direction, AnimationsMap } from './constants';
import { transtionGroupStyles, itemStyles } from './styles';

interface Props {
  rooms: ListingPreviewCard[];
  onClose: () => void;
}

export default class SearchMapPreview extends React.Component<Props> {
  state = {
    previousRoomIndex: 0,
    currentRoomIndex: 0,
  };

  handlePreviousClick: React.MouseEventHandler<HTMLButtonElement> = () => {
    const { currentRoomIndex } = this.state;

    this.setState({
      currentRoomIndex: currentRoomIndex - 1,
      previousRoomIndex: currentRoomIndex,
    });
  };

  handleNextClick: React.MouseEventHandler<HTMLButtonElement> = () => {
    const { currentRoomIndex } = this.state;

    this.setState({
      currentRoomIndex: currentRoomIndex + 1,
      previousRoomIndex: currentRoomIndex,
    });
  };

  render() {
    const { rooms } = this.props;
    const { currentRoomIndex, previousRoomIndex } = this.state;

    const isMoreThenOneRoom = rooms.length > 1;
    const visibleRoom = rooms[currentRoomIndex];
    const direction =
      currentRoomIndex >= previousRoomIndex
        ? Direction.FORWARD
        : Direction.BACKWARD;
    const { leave, enter } = AnimationsMap[direction];

    return (
      <div data-test-locator="Search Map Preview">
        {isMoreThenOneRoom && (
          <SearchMapPreviewControls
            rooms={rooms}
            currentRoomIndex={currentRoomIndex}
            onClose={this.props.onClose}
            onPreviousClick={this.handlePreviousClick}
            onNextClick={this.handleNextClick}
          />
        )}
        <TransitionGroup>
          <CSSTransition
            classNames={cx(leave, enter)}
            style={transtionGroupStyles}
            timeout={{ enter: 600, exit: 600 }}
          >
            <div
              key={visibleRoom.id}
              style={isMoreThenOneRoom ? itemStyles : {}}
            >
              <ListingPreviewCardTracked
                listingId={visibleRoom.id}
                listingProps={{
                  room: visibleRoom,
                  key: visibleRoom.id,
                  isMapMarker: true,
                }}
                trackLocation="map"
              />
            </div>
          </CSSTransition>
        </TransitionGroup>
      </div>
    );
  }
}
